/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    EcomailUsersCountDto,
    EcomailUsersCountDtoFromJSON,
    EcomailUsersCountDtoToJSON,
    InterestedInSubscriptionDto,
    InterestedInSubscriptionDtoFromJSON,
    InterestedInSubscriptionDtoToJSON,
    NicknameAlreadyTakenDto,
    NicknameAlreadyTakenDtoFromJSON,
    NicknameAlreadyTakenDtoToJSON,
    PaginatedActiveUserDto,
    PaginatedActiveUserDtoFromJSON,
    PaginatedActiveUserDtoToJSON,
    PaginatedNotConfirmedUserDto,
    PaginatedNotConfirmedUserDtoFromJSON,
    PaginatedNotConfirmedUserDtoToJSON,
    PaginatedWaitingUserDto,
    PaginatedWaitingUserDtoFromJSON,
    PaginatedWaitingUserDtoToJSON,
    ProfileFormValuesDto,
    ProfileFormValuesDtoFromJSON,
    ProfileFormValuesDtoToJSON,
    SetNewsletterDto,
    SetNewsletterDtoFromJSON,
    SetNewsletterDtoToJSON,
    SourceSurveyDto,
    SourceSurveyDtoFromJSON,
    SourceSurveyDtoToJSON,
    UpdateStornoReasonDto,
    UpdateStornoReasonDtoFromJSON,
    UpdateStornoReasonDtoToJSON,
    UpdateUserSettingsDto,
    UpdateUserSettingsDtoFromJSON,
    UpdateUserSettingsDtoToJSON,
    UserActivateDto,
    UserActivateDtoFromJSON,
    UserActivateDtoToJSON,
    UserSettingsDto,
    UserSettingsDtoFromJSON,
    UserSettingsDtoToJSON,
} from '../models';

export interface UserControllerActivateRequest {
    userActivateDto: UserActivateDto;
}

export interface UserControllerDeleteUserRequest {
    userId: string;
}

export interface UserControllerGetActiveRequest {
    limit: number;
    offset: number;
    subscription?: string;
    phrase?: string;
}

export interface UserControllerGetNotConfirmedRequest {
    limit: number;
    offset: number;
    phrase?: string;
}

export interface UserControllerGetWaitingRequest {
    limit: number;
    offset: number;
    phrase?: string;
}

export interface UserControllerIsNicknameAlreadyTakenRequest {
    nickname: string;
}

export interface UserControllerPinPortfolioRequest {
    portfolioId: string;
}

export interface UserControllerSetNewsletterRequest {
    setNewsletterDto: SetNewsletterDto;
}

export interface UserControllerUnpinPortfolioRequest {
    portfolioId: string;
}

export interface UserControllerUpdateInterestedInSubscriptionRequest {
    interestedInSubscriptionDto: InterestedInSubscriptionDto;
}

export interface UserControllerUpdateProfileRequest {
    profileFormValuesDto: ProfileFormValuesDto;
}

export interface UserControllerUpdateSettingsRequest {
    updateUserSettingsDto: UpdateUserSettingsDto;
}

export interface UserControllerUpdateSourceSurveyRequest {
    sourceSurveyDto: SourceSurveyDto;
}

export interface UserControllerUpdateStornoReasonRequest {
    updateStornoReasonDto: UpdateStornoReasonDto;
}

/**
 * 
 */
export class UsersApi extends runtime.BaseAPI {

    /**
     * Activate selected users on waitlist and send them email
     */
    async userControllerActivateRaw(requestParameters: UserControllerActivateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.userActivateDto === null || requestParameters.userActivateDto === undefined) {
            throw new runtime.RequiredError('userActivateDto','Required parameter requestParameters.userActivateDto was null or undefined when calling userControllerActivate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/activate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserActivateDtoToJSON(requestParameters.userActivateDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Activate selected users on waitlist and send them email
     */
    async userControllerActivate(requestParameters: UserControllerActivateRequest, initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.userControllerActivateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Agree terms and conditions
     */
    async userControllerAgreeTermsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/agree-terms`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Agree terms and conditions
     */
    async userControllerAgreeTerms(initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.userControllerAgreeTermsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Delete my account
     */
    async userControllerDeleteAccountRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/my-account`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Delete my account
     */
    async userControllerDeleteAccount(initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.userControllerDeleteAccountRaw(initOverrides);
        return await response.value();
    }

    /**
     * Delete user by id
     */
    async userControllerDeleteUserRaw(requestParameters: UserControllerDeleteUserRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userControllerDeleteUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Delete user by id
     */
    async userControllerDeleteUser(requestParameters: UserControllerDeleteUserRequest, initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.userControllerDeleteUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get active users
     */
    async userControllerGetActiveRaw(requestParameters: UserControllerGetActiveRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PaginatedActiveUserDto>> {
        if (requestParameters.limit === null || requestParameters.limit === undefined) {
            throw new runtime.RequiredError('limit','Required parameter requestParameters.limit was null or undefined when calling userControllerGetActive.');
        }

        if (requestParameters.offset === null || requestParameters.offset === undefined) {
            throw new runtime.RequiredError('offset','Required parameter requestParameters.offset was null or undefined when calling userControllerGetActive.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.subscription !== undefined) {
            queryParameters['subscription'] = requestParameters.subscription;
        }

        if (requestParameters.phrase !== undefined) {
            queryParameters['phrase'] = requestParameters.phrase;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/active`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedActiveUserDtoFromJSON(jsonValue));
    }

    /**
     * Get active users
     */
    async userControllerGetActive(requestParameters: UserControllerGetActiveRequest, initOverrides?: RequestInit): Promise<PaginatedActiveUserDto> {
        const response = await this.userControllerGetActiveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get ecomail users count
     */
    async userControllerGetEcomailUsersCountRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<EcomailUsersCountDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/ecomail-users-count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EcomailUsersCountDtoFromJSON(jsonValue));
    }

    /**
     * Get ecomail users count
     */
    async userControllerGetEcomailUsersCount(initOverrides?: RequestInit): Promise<EcomailUsersCountDto> {
        const response = await this.userControllerGetEcomailUsersCountRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get users emails that do not match with ecomail
     */
    async userControllerGetNonMatchingEcomailUsersRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/non-matching-ecomail-users`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get users emails that do not match with ecomail
     */
    async userControllerGetNonMatchingEcomailUsers(initOverrides?: RequestInit): Promise<Array<string>> {
        const response = await this.userControllerGetNonMatchingEcomailUsersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get not confirmed users
     */
    async userControllerGetNotConfirmedRaw(requestParameters: UserControllerGetNotConfirmedRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PaginatedNotConfirmedUserDto>> {
        if (requestParameters.limit === null || requestParameters.limit === undefined) {
            throw new runtime.RequiredError('limit','Required parameter requestParameters.limit was null or undefined when calling userControllerGetNotConfirmed.');
        }

        if (requestParameters.offset === null || requestParameters.offset === undefined) {
            throw new runtime.RequiredError('offset','Required parameter requestParameters.offset was null or undefined when calling userControllerGetNotConfirmed.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.phrase !== undefined) {
            queryParameters['phrase'] = requestParameters.phrase;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/not-confirmed`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedNotConfirmedUserDtoFromJSON(jsonValue));
    }

    /**
     * Get not confirmed users
     */
    async userControllerGetNotConfirmed(requestParameters: UserControllerGetNotConfirmedRequest, initOverrides?: RequestInit): Promise<PaginatedNotConfirmedUserDto> {
        const response = await this.userControllerGetNotConfirmedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get rounded count of users
     */
    async userControllerGetRoundedCountRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/rounded-count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Get rounded count of users
     */
    async userControllerGetRoundedCount(initOverrides?: RequestInit): Promise<number> {
        const response = await this.userControllerGetRoundedCountRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get user settings
     */
    async userControllerGetSettingsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<UserSettingsDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSettingsDtoFromJSON(jsonValue));
    }

    /**
     * Get user settings
     */
    async userControllerGetSettings(initOverrides?: RequestInit): Promise<UserSettingsDto> {
        const response = await this.userControllerGetSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get users on waiting list
     */
    async userControllerGetWaitingRaw(requestParameters: UserControllerGetWaitingRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PaginatedWaitingUserDto>> {
        if (requestParameters.limit === null || requestParameters.limit === undefined) {
            throw new runtime.RequiredError('limit','Required parameter requestParameters.limit was null or undefined when calling userControllerGetWaiting.');
        }

        if (requestParameters.offset === null || requestParameters.offset === undefined) {
            throw new runtime.RequiredError('offset','Required parameter requestParameters.offset was null or undefined when calling userControllerGetWaiting.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.phrase !== undefined) {
            queryParameters['phrase'] = requestParameters.phrase;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/waiting`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedWaitingUserDtoFromJSON(jsonValue));
    }

    /**
     * Get users on waiting list
     */
    async userControllerGetWaiting(requestParameters: UserControllerGetWaitingRequest, initOverrides?: RequestInit): Promise<PaginatedWaitingUserDto> {
        const response = await this.userControllerGetWaitingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get waiting list order
     */
    async userControllerGetWaitingOrderRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/waiting-order`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Get waiting list order
     */
    async userControllerGetWaitingOrder(initOverrides?: RequestInit): Promise<number> {
        const response = await this.userControllerGetWaitingOrderRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get if user has storno discount
     */
    async userControllerHadStornoDiscountRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/storno-discount`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Get if user has storno discount
     */
    async userControllerHadStornoDiscount(initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.userControllerHadStornoDiscountRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get mail overview period
     */
    async userControllerIsNicknameAlreadyTakenRaw(requestParameters: UserControllerIsNicknameAlreadyTakenRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NicknameAlreadyTakenDto>> {
        if (requestParameters.nickname === null || requestParameters.nickname === undefined) {
            throw new runtime.RequiredError('nickname','Required parameter requestParameters.nickname was null or undefined when calling userControllerIsNicknameAlreadyTaken.');
        }

        const queryParameters: any = {};

        if (requestParameters.nickname !== undefined) {
            queryParameters['nickname'] = requestParameters.nickname;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/nickname-already-taken`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NicknameAlreadyTakenDtoFromJSON(jsonValue));
    }

    /**
     * Get mail overview period
     */
    async userControllerIsNicknameAlreadyTaken(requestParameters: UserControllerIsNicknameAlreadyTakenRequest, initOverrides?: RequestInit): Promise<NicknameAlreadyTakenDto> {
        const response = await this.userControllerIsNicknameAlreadyTakenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Pin shared portfolio
     */
    async userControllerPinPortfolioRaw(requestParameters: UserControllerPinPortfolioRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.portfolioId === null || requestParameters.portfolioId === undefined) {
            throw new runtime.RequiredError('portfolioId','Required parameter requestParameters.portfolioId was null or undefined when calling userControllerPinPortfolio.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/pin-portfolio/{portfolioId}`.replace(`{${"portfolioId"}}`, encodeURIComponent(String(requestParameters.portfolioId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Pin shared portfolio
     */
    async userControllerPinPortfolio(requestParameters: UserControllerPinPortfolioRequest, initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.userControllerPinPortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set newsletter for current user
     */
    async userControllerSetNewsletterRaw(requestParameters: UserControllerSetNewsletterRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.setNewsletterDto === null || requestParameters.setNewsletterDto === undefined) {
            throw new runtime.RequiredError('setNewsletterDto','Required parameter requestParameters.setNewsletterDto was null or undefined when calling userControllerSetNewsletter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/set-newsletter`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetNewsletterDtoToJSON(requestParameters.setNewsletterDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Set newsletter for current user
     */
    async userControllerSetNewsletter(requestParameters: UserControllerSetNewsletterRequest, initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.userControllerSetNewsletterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Pin shared portfolio
     */
    async userControllerUnpinPortfolioRaw(requestParameters: UserControllerUnpinPortfolioRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.portfolioId === null || requestParameters.portfolioId === undefined) {
            throw new runtime.RequiredError('portfolioId','Required parameter requestParameters.portfolioId was null or undefined when calling userControllerUnpinPortfolio.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/unpin-portfolio/{portfolioId}`.replace(`{${"portfolioId"}}`, encodeURIComponent(String(requestParameters.portfolioId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Pin shared portfolio
     */
    async userControllerUnpinPortfolio(requestParameters: UserControllerUnpinPortfolioRequest, initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.userControllerUnpinPortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update interested in subscription for current user
     */
    async userControllerUpdateInterestedInSubscriptionRaw(requestParameters: UserControllerUpdateInterestedInSubscriptionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.interestedInSubscriptionDto === null || requestParameters.interestedInSubscriptionDto === undefined) {
            throw new runtime.RequiredError('interestedInSubscriptionDto','Required parameter requestParameters.interestedInSubscriptionDto was null or undefined when calling userControllerUpdateInterestedInSubscription.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/interested-in-subscription`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InterestedInSubscriptionDtoToJSON(requestParameters.interestedInSubscriptionDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Update interested in subscription for current user
     */
    async userControllerUpdateInterestedInSubscription(requestParameters: UserControllerUpdateInterestedInSubscriptionRequest, initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.userControllerUpdateInterestedInSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update profile for current user
     */
    async userControllerUpdateProfileRaw(requestParameters: UserControllerUpdateProfileRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.profileFormValuesDto === null || requestParameters.profileFormValuesDto === undefined) {
            throw new runtime.RequiredError('profileFormValuesDto','Required parameter requestParameters.profileFormValuesDto was null or undefined when calling userControllerUpdateProfile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/update-profile`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProfileFormValuesDtoToJSON(requestParameters.profileFormValuesDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Update profile for current user
     */
    async userControllerUpdateProfile(requestParameters: UserControllerUpdateProfileRequest, initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.userControllerUpdateProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update user settings
     */
    async userControllerUpdateSettingsRaw(requestParameters: UserControllerUpdateSettingsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.updateUserSettingsDto === null || requestParameters.updateUserSettingsDto === undefined) {
            throw new runtime.RequiredError('updateUserSettingsDto','Required parameter requestParameters.updateUserSettingsDto was null or undefined when calling userControllerUpdateSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/settings`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserSettingsDtoToJSON(requestParameters.updateUserSettingsDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Update user settings
     */
    async userControllerUpdateSettings(requestParameters: UserControllerUpdateSettingsRequest, initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.userControllerUpdateSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update source survey
     */
    async userControllerUpdateSourceSurveyRaw(requestParameters: UserControllerUpdateSourceSurveyRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.sourceSurveyDto === null || requestParameters.sourceSurveyDto === undefined) {
            throw new runtime.RequiredError('sourceSurveyDto','Required parameter requestParameters.sourceSurveyDto was null or undefined when calling userControllerUpdateSourceSurvey.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/source-survey`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SourceSurveyDtoToJSON(requestParameters.sourceSurveyDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Update source survey
     */
    async userControllerUpdateSourceSurvey(requestParameters: UserControllerUpdateSourceSurveyRequest, initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.userControllerUpdateSourceSurveyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set storno reason for current user
     */
    async userControllerUpdateStornoReasonRaw(requestParameters: UserControllerUpdateStornoReasonRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.updateStornoReasonDto === null || requestParameters.updateStornoReasonDto === undefined) {
            throw new runtime.RequiredError('updateStornoReasonDto','Required parameter requestParameters.updateStornoReasonDto was null or undefined when calling userControllerUpdateStornoReason.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/storno-reason`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateStornoReasonDtoToJSON(requestParameters.updateStornoReasonDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Set storno reason for current user
     */
    async userControllerUpdateStornoReason(requestParameters: UserControllerUpdateStornoReasonRequest, initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.userControllerUpdateStornoReasonRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
